module.exports = __webpack_public_path__ + "img/detector-bg.9427ad8.jpg";